/**
stats-overview
*/


<template>
    <div>
        <p class="chart-title">The Wildlife Trusts' MPA Recovery Check overview statistics.</p>

        <div id="mpa-condition-count"></div>

        <p style="font-size: 80%">Notes: hover the bars to show how many sites contributed to these percentages. Additional information on how the condition has been assessed can be found in the information section. The number of MPAs may not be a whole number due to some MPAs being split between different countries.</p>

    </div>
</template>


<script>
import store from "../store/reality-check-store";


export default {
    name: "stats-condition",
    components: {},
    store,
    props: {
        stateChange: {type: Number, required: true}  // to trigger redraw
    },
    data: function () {
        return {
            preparedData: undefined
        }
    },
    methods: {
        drawConditionChart: function () {
            if (!this.conditionData) {
                return
            }

            this.prepareChartData();

            const layout = {
                barmode: "stack", showlegend: true,
                // width: 900,
                autosize: true,
                margin: {
                    t: 60, r: 0, b: 80, l: 100
                },
                legend: {
                    x: .75,
                    y: -0.3,
                    traceorder: "normal",
                },
                title: "Percentage of MPAs in different recovery categories",
                hovermode: "y",
                xaxis: {
                    title: 'Percentage of MPAs',
                    ticksuffix: " %",
                    tickformat: ',.1f',
                    showticksuffix: "last"
                },
                yaxis: {
                    autorange: "reversed",
                }
            }

            Plotly.newPlot("mpa-condition-count", this.preparedData, layout, {responsive: true});

            document.getElementById("mpa-condition-count").on("plotly_hover", function (e) {
            //     // https://plotly.com/javascript/hover-events/#coupled-hover-events
                var points = e.points[0], pointNum = points.pointNumber;

                Plotly.Fx.hover("mpa-condition-count", [
                    {curveNumber: 0, pointNumber: pointNum},
                    {curveNumber: 1, pointNumber: pointNum},
                    {curveNumber: 2, pointNumber: pointNum},
                    {curveNumber: 3, pointNumber: pointNum},
                ])
            })

        },
        prepareChartData: function () {
            if (this.preparedData) {
                return
            }

            var x1 = [], x2 = [], x3 = [], x1perc = [], x2perc = [], x3perc = [];
            var y = ["UK", "England", "Scotland", "Wales", "Northern Ireland"];

            for (const location of y) {
                for (const row in this.conditionData[location]) {
                    switch (row){
                        case "Recovered/recovering":
                            x1perc.push(this.conditionData[location][row])
                            x1.push((this.conditionData[location][row] / this.conditionData[location]["total"] * 100).toFixed(1) + "%")
                            break;
                        case "Degraded/degrading":
                            x2perc.push(this.conditionData[location][row])
                            x2.push((this.conditionData[location][row] / this.conditionData[location]["total"] * 100).toFixed(1) + "%")
                            break;
                        case "Condition unknown":
                            x3perc.push(this.conditionData[location][row])
                            x3.push((this.conditionData[location][row] / this.conditionData[location]["total"] * 100).toFixed(1) + "%")
                            break;
                    }
                }
            }

            y[4] = "Northern<br>Ireland"

            this.preparedData = [
                {
                    "type": "bar",
                    "name": "Recovered/recovering",
                    "x": x1,
                    "y": y,
                    "orientation": "h",
                    "text": x1perc,
                    "hoverinfo": "x+text",
                    "textposition": "none",
                    "marker": {
                        "color": "rgba(124, 184, 84, 1)"
                    }
                },
                {
                    "type": "bar",
                    "name": "Degraded/degrading",
                    "x": x2,
                    "y": y,
                    "orientation": "h",
                    "text": x2perc,
                    "hoverinfo": "x+text",
                    "textposition": "none",
                    "marker": {
                        "color": "rgb(131,33,33)"
                    }
                },
                {
                    "type": "bar",
                    "name": "Condition unknown",
                    "x": x3,
                    "y": y,
                    "orientation": "h",
                    "text": x3perc,
                    "hoverinfo": "x+text",
                    "textposition": "none",
                    "marker": {
                        "color": "rgb(199,199,199)"
                    }
                }
            ];

        }
    },
    computed: {
        conditionData: function () {
            return this.$store.state.stats.conditionData
        }
    },
    watch: {
        conditionData: function () {
            if (this.conditionData) {
                this.drawConditionChart()
            }
        },
        stateChange: function () {
            this.drawConditionChart();
        }
    },
    mounted: function () {
        window.onresize =  function () {
            this.drawConditionChart();  // forces a redraw which also adjusts which text is displayed
        }.bind(this)
    }
}
</script>


<style lang="scss">
    @import "../../../styles/variables.scss";

    #area-overview, #mpa-overview {
        margin-bottom: 20px;
    }
</style>